import { render, staticRenderFns } from "./findPwd.vue?vue&type=template&id=ef9d62e0&scoped=true&"
import script from "./findPwd.vue?vue&type=script&lang=js&"
export * from "./findPwd.vue?vue&type=script&lang=js&"
import style0 from "./findPwd.vue?vue&type=style&index=0&id=ef9d62e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9d62e0",
  null
  
)

export default component.exports